import { AI_SUGGESTED_QUESTIONS } from "./aiAssistantConfig";

function SuggestedQuestions({ onSelectQuestion, disabled }) {
   return (
      <div className="ai-suggestions">
         {AI_SUGGESTED_QUESTIONS.map((question) => (
            <button
               key={question.id}
               type="button"
               className="ai-suggestion-button"
               onClick={() => onSelectQuestion(question.text)}
               disabled={disabled}
            >
               <span className="ai-suggestion-content">
                  <span className="ai-suggestion-icon" aria-hidden="true">
                     {question.homeIcon}
                  </span>
                  {question.text}
               </span>
               <span className="ai-suggestion-arrow" aria-hidden="true">
                  ›
               </span>
            </button>
         ))}
      </div>
   );
}

export default SuggestedQuestions;
